<template>
    <div>
        <vx-card title="FATURAMENTO" >
            <template slot="actions">
                <h3>{{ totalSumDays | currency }}</h3>
            </template>

                <div class="line-area-chart">
                    <vue-apex-charts ref="apexChart" width='100%' type="area" height=300 :options="chartOptions" :series="chartData" />
                </div>
        </vx-card>
    </div>
</template>

<script>
    import VueApexCharts from 'vue-apexcharts'
    import { currentApexLocale } from '../apexChartConfig.js'

    export default {
        props : ['paymentData'],

        components : {
            VueApexCharts
        },

        data () {
            return {
                totalSumDays : 0,
                chartData: [{
                        name: 'Faturamento',
                        data: [490.93, 293.69, 1039.29, 1203.50, 893.19, 900.00, 753.09]
                    }],
                chartOptions: {
                    
                    xaxis: {
                        labels : {
                            datetimeFormatter : {
                                year : 'YYYY',
                                month : 'MMMM',
                                day: 'dd',
                                hour : ''
                            }
                        },
                        type: 'datetime',
                        categories: [
                            "2018-09-19", "2018-09-20", "2018-09-21",
                            "2018-09-22", "2018-09-23", "2018-09-24",
                            "2018-09-25"
                        ]
                    },
                    grid: {
                        show: true,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    chart: {
                        defaultLocale: this.$i18n.locale,
                        locales : currentApexLocale,
                        type: 'area',
                        dropShadow: {
                            enabled: true,
                            top: 5,
                            left: 0,
                            blur: 4,
                            opacity: 0.10,
                        },
                        toolbar: {
                            show: false,
                        },
                        sparkline: {
                            enabled: false
                        },
                        zoom : false
                    },
                    stroke: {
                        width: 5,
                        curve: 'straight'
                    },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shade: 'dark',
                            gradientToColors: ['#ea5455'],
                            shadeIntensity: 0,
                            type: 'vertical',
                            opacityFrom: 0.6,
                            opacityTo: 0,
                            stops: [0, 100, 100, 100]
                        },
                    },
                    colors: ['#ea5455'],
                    markers: {
                        size: 1,
                        hover: {
                            size: 5
                        }
                    },
                    tooltip: {
                        x: { 
                            format: '(dddd) dd / MMMM',
                            // formatter : (val) => {
                            //     return `${this.$t(this.$options.filters.moment(val, 'MMMM'))}`
                            // },
                            show: true 
                        },
                        y: {
                            formatter: (val) => {
                                return this.$options.filters.currency(val)
                            }
                        }
                    },
                }
            }
        },

        created () {
            this.changeChart()
        },

        methods : {
            changeChart () {
                let totalSum = 0
                let chartData = []
                let days = []

                this.paymentData.forEach(data => {
                    let payment = data.data()
                    let totalPaymentPerType = 0;
                    
                    if(payment.hasOwnProperty('payments')) {
                        Object.entries(payment.payments).forEach(pType => {
                            totalPaymentPerType += pType[1].value
                        })
                    }

                    totalSum += totalPaymentPerType
                    chartData.push(totalPaymentPerType.toFixed(2))
                    days.push(data.id)
                })

                this.totalSumDays = totalSum;
                this.$set(this.chartData[0], 'data', chartData)
                this.$set(this.chartOptions.xaxis, 'categories', days)
            },

        }
    }
</script>